import { Component, computed, ElementRef, Input, OnInit, Signal, signal, ViewChild } from '@angular/core';
import { FloorPlanInfo, Place } from 'src/app/interfaces/interfaces';
import { ApiService } from 'src/app/services/api-services/api.service';
import { FloorplanSearchService } from '../search/floorplan-search.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, PopoverController, ToastController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast-service/toast.service';
import { StaticCanvas, Image, Text, util, Group } from 'fabric'
import { PlacesService } from 'src/app/services/placesService/places.service';
import { UserStore } from 'src/app/stores/user.store';
import { PlacesStore } from 'src/app/stores/places.store';
import { FloorplanStore } from 'src/app/stores/floorplan.store';

@Component({
  selector: 'app-favorite-map-item',
  templateUrl: './favorite-map-item.component.html',
  styleUrls: ['./favorite-map-item.component.scss'],
})
export class FavoriteMapItemComponent implements OnInit {
  @Input() floorplan: FloorPlanInfo
  isLoading = false
  isItemLoading: boolean;
  linkedResourcesCount = 0
  linkedResources : string[]
  mapPreviewPopOverIsOpen = false
  linkedResourcesPopOverIsOpen = false
  canvas: any;
  
  
  linkedResourcesAsPlaces : Signal<Place[]> = computed(() => this.placesStore.places().filter(item=> this.linkedResources.includes(item.emailAddress)))

  @ViewChild('mapPreviewPopOver') mapPreviewPopOver;
  @ViewChild('linkedResourcesPopOver') linkedResourcesPopOver;
  @ViewChild('floorCanvasPreview', { static: false }) floorCanvasPreview!: ElementRef;

  constructor(private placesStore:PlacesStore,private popoverController : PopoverController,private floorplanSearchService:FloorplanSearchService,private router:Router,private translateService: TranslateService,private toastService : ToastService,private alertController:AlertController, private userStore: UserStore, private floorplanStore: FloorplanStore) { 
  }

  ngOnInit() { 
    if(!this.floorplan.floorMapImage.startsWith("data")) {

      this.linkedResourcesCount = JSON.parse(this.floorplan.floorMapImage).objects.length - 1
      this.linkedResources = JSON.parse(this.floorplan.floorMapImage).objects.map(obj => obj.name)
      this.linkedResources.shift() //to remove the image from the list:/
    }
  }



  toggleFavorite(map:FloorPlanInfo) {
    this.isItemLoading = true
    this.userStore.toggleMapFavorite(map._id).then(() => {
      this.isItemLoading = false
    }).catch(() => {
      this.isItemLoading = false
      this.toggleFavMapWentWrongToast()
    })
  }

  openMap(map:FloorPlanInfo) {  
    this.isLoading = true
    if(map.floorMapImage == null) return this.noFloorplanImageFoundToast()
    this.floorplanSearchService.applySearch(map)
    this.isLoading = false 
  }

  openMapPreview(event) {
    this.mapPreviewPopOver.event = event;
    this.mapPreviewPopOverIsOpen = true;    
    setTimeout(() => {
      if(this.floorplan.floorMapImage.startsWith("data")) {
        this.initAndLoadNormalImage()
      } else {
        this.initAndDrawCanvasWithAvailibility();
      }
    }, 100);
  }
  
  
  async presentMapPreviewInteracionAlert(floorplan) {
    let alertButtons = [
      {
        text: this.translateService.instant('cancelButton'),
        role: 'cancel',
        handler: () => {
          this.popoverController.dismiss()
        }
      },
      {
        text: this.translateService.instant('floorPlan.openMap'),
        role: 'confirm',
        handler: () => {
          this.popoverController.dismiss()
          // this.dismissMapPreview();
          this.openMap(floorplan)

        },
      },
    ];
    const alert = await this.alertController.create({
      header: this.translateService.instant('floorPlan.mapPopupMessage'),
      message: '',
      cssClass: "map-interaction-alert",
      buttons: alertButtons,
    });

    await alert.present();
  }

  private initAndLoadNormalImage() {
    this.canvas = new StaticCanvas(this.floorCanvasPreview.nativeElement);

   
    Image.fromURL(this.floorplan.floorMapImage).then((object) => {
      this.canvas.setWidth(300);
      this.canvas.setHeight(200);
      const scaleX = this.canvas.width / object.width;
      const scaleY = this.canvas.height / object.height;
      const scaleFactor = Math.min(scaleX, scaleY); // Set the viewport properties
      this.canvas.setViewportTransform([
        scaleFactor,
        0,
        0,
        scaleFactor ,
        (this.canvas.width - object.width * scaleFactor) ,
        (this.canvas.height - object.height * scaleFactor) ,
      ]);

      object.set({
        left: this.canvas.width / 2,
        top: this.canvas.height / 2,
        originX: 'center',
        originY: 'center',
        hasControls: false,
        selectable: false,
        name : "planImage"
      });
      this.canvas.add(object);
      this.canvas.viewportCenterObject(object);
      this.canvas.requestRenderAll();
    });
  }
  private async initAndDrawCanvasWithAvailibility() {
    try {
     
      const json = JSON.parse(this.floorplan.floorMapImage);
      json.version = '6.0.0';
  
      
      this.canvas = new StaticCanvas(this.floorCanvasPreview.nativeElement, {
        width: 300,
        height: 200,
        backgroundColor: '#ffffff' // Ensure background is visible
      });
  
      // modern v6 approach
      await this.canvas.loadFromJSON(json);
      
      
      const objects = this.canvas.getObjects();
    
      
      if (objects.length === 0) {
        throw new Error('No objects loaded - check your JSON structure');
      }
  
      // bounding box
      const boundingRect = this.calculateBoundingBox(objects);
      const boundingWidth = boundingRect.right - boundingRect.left;
      const boundingHeight = boundingRect.bottom - boundingRect.top;
  
      // scaling and positioning
      const scaleFactorWidth = this.canvas.getWidth() / boundingWidth;
      const scaleFactorHeight = this.canvas.getHeight() / boundingHeight;
      const scaleFactor = Math.min(scaleFactorWidth, scaleFactorHeight);
      
      const offsetX = (this.canvas.getWidth() - boundingWidth * scaleFactor) / 2;
      const offsetY = (this.canvas.getHeight() - boundingHeight * scaleFactor) / 2;
  
      // Transform objects
      objects.forEach(obj => {
        obj.scaleX *= scaleFactor;
        obj.scaleY *= scaleFactor;
        obj.left = (obj.left - boundingRect.left) * scaleFactor + offsetX;
        obj.top = (obj.top - boundingRect.top) * scaleFactor + offsetY;
        obj.setCoords();
        
        this.colorShapesBasedOnAvailibility(obj);
      });
      this.canvas.requestRenderAll();
    } catch (error) {
      console.error('Canvas initialization failed:', error);
    }
  }
  
  private calculateBoundingBox(objects:any) {
    return objects.reduce((acc, obj) => {
      const objRect = obj.getBoundingRect();
      return {
        left: Math.min(acc.left, objRect.left),
        top: Math.min(acc.top, objRect.top),
        right: Math.max(acc.right, objRect.left + objRect.width),
        bottom: Math.max(acc.bottom, objRect.top + objRect.height)
      };
    }, { 
      left: Infinity, 
      top: Infinity, 
      right: -Infinity, 
      bottom: -Infinity 
    });
  }
  
  // Updated coloring function for v6
  private colorShapesBasedOnAvailibility(obj:any) {
    const place = this.linkedResourcesAsPlaces().find(
      (item: any) => item.emailAddress === (obj as any).name
    );
  
    if (!place) {
      obj.set({
        fill: 'rgba(0,0,0,0.5)',
        stroke: '#000',
        strokeWidth: 1
      });
      return;
    }
  
    const isAvailable = place.isAvailable;
    const colorSettings = isAvailable ? {
      fill: "rgba(40,176,11,0.2)",
      stroke: "rgba(40,176,11,1)",
      strokeWidth: 4
    } : {
      fill: "rgba(224,6,28,0.2)",
      stroke: "rgba(224,6,28,1)",
      strokeWidth: 4
    };
  
    // Handle groups differently
    if (obj.type === 'group') {
      const group = obj as Group;
      group.getObjects().forEach(subObj => {
        subObj.set(colorSettings);
      });
    } else {
      obj.set(colorSettings);
      this.addCapacityLabel(obj, place, isAvailable);
    }
  }
  
  private addCapacityLabel(obj: any, place: any, isAvailable: boolean) {
    let capacityText = '';
    
    if (place.type === "room") {
      capacityText = place?.capacity?.toString() || '-';
    } else {
      capacityText = `${place?.availableSpace ?? '-'}/${place?.capacity ?? '-'}`;
    }
  
    const text = new Text(capacityText, {
      fill: isAvailable ? "rgba(40,176,11,1)" : "rgba(224,6,28,1)",
      originX: "center",
      originY: "center",
      fontSize: 12, // Start smaller - will scale
      fontFamily: "Open Sans",
      selectable: false
    });
  
    // Scale text to object size
    const scaleFactor = Math.min(obj.scaleX || 1, obj.scaleY || 1);
    text.set({
      fontSize: Math.max(8, 12 * scaleFactor) // Minimum 8px
    });
  
    // Position text
    const center = obj.getCenterPoint();
    text.setPositionByOrigin(center, 'center', 'center');
    
    this.canvas.add(text);
    this.canvas.bringObjectToFront(text);
  }
 

  dismissMapPreview() {
    this.mapPreviewPopOverIsOpen = false
    this.canvas.dispose()
  }


  openLinkedResourcesPopOver(event) {
    this.linkedResourcesPopOver.event = event;
    this.linkedResourcesPopOverIsOpen = true
  }

  dismissLinkedResourcesPopOver() {
    this.linkedResourcesPopOverIsOpen = false

  }

  async toggleFavMapWentWrongToast() { 
    this.isItemLoading = false
    this.toastService.openErrorToastAsync('toggleFavMapWentWrongToast')
  } 


  async noFloorplanImageFoundToast() {
    this.isLoading = false
    await this.toastService.openActionToastAsync({
      message: "noFloorplanImageFound",
      duration: 10000,
      color: 'danger',
      cssClass: 'custom-toast-button',
      layout: 'stacked',
      buttons: [
            {
              text: this.translateService.instant("refreshFloorplans"),
              icon:"sync",
              handler: () => {
                this.isLoading=true
                this.floorplanStore.getFloorplanList();
                setTimeout(()=> this.isLoading=false, 2000)
              }
            }
          ]
    });
  } 
}